"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderAnalytics = void 0;
require("ag-grid-community/dist/styles/ag-grid.css");
require("ag-grid-community/dist/styles/ag-theme-balham.css");
const ag_grid_react_1 = require("ag-grid-react");
const ui_1 = require("client/components/ui");
const order_analytics_header_1 = require("client/modules/reporting/modules/reporting-list/components/report-container/order-analytics/components/order-analytics-header");
const store_1 = require("client/modules/reporting/store");
const mobx_react_1 = require("mobx-react");
const React = require("react");
const no_data_found_1 = require("../no-data-found/no-data-found");
const number_formatter_1 = require("../claim-analytics/number-formatter");
const number_formatter_order_analytic_1 = require("../claim-analytics/number-formatter-order-analytic");
require("./order-analytics.less");
const store_2 = require("client/modules/users/store"); //B-088
let OrderAnalytics = class OrderAnalytics extends React.Component {
    constructor(props) {
        super(props);
        this.onButtonExport = () => {
            const params = {
                fileName: "Order_Analytics.csv"
            };
            this.storeData.gridApi.exportDataAsCsv(params);
        };
        this.storeData = {
            defaultColDef: {
                enablePivot: true,
                enableRowGroup: true,
                enableValue: true,
                sortable: true,
                resizable: true,
                filter: true,
                comparator(a, b) {
                    if (typeof a === "string") {
                        return a.localeCompare(b);
                    }
                    else {
                        return a > b ? 1 : a < b ? -1 : 0;
                    }
                }
            },
            columnDefs: [
                {
                    headerName: "Purchase Order Id",
                    field: "Purchase Order Id",
                    enableRowGroup: true
                },
                {
                    headerName: "Type",
                    field: "type",
                    enableRowGroup: true
                },
                {
                    headerName: "Order Status",
                    field: "Order Status",
                    enableRowGroup: true
                },
                {
                    headerName: "Pharmacy Name",
                    field: "Pharmacy Name",
                    filter: "agTextColumnFilter",
                    enableRowGroup: true
                },
                {
                    headerName: "Med Name",
                    field: "Med Name",
                    filter: "agTextColumnFilter",
                    enableRowGroup: true
                },
                {
                    headerName: "Distributor Name",
                    field: "Distributor Name",
                    filter: "agTextColumnFilter",
                    enableRowGroup: true
                },
                {
                    headerName: "NDC #",
                    field: "NDC #",
                    filter: "agTextColumnFilter",
                    enableRowGroup: true
                },
                {
                    headerName: "Date Sent To Distributor",
                    field: "Date Sent To Distributor",
                    filter: "agDateColumnFilter",
                    filterParams: {
                        comparator: (filterLocalDateAtMidnight, cellValue) => {
                            const dateAsString = cellValue;
                            if (dateAsString === null)
                                return -1;
                            const dateParts = dateAsString.split("/");
                            const cellDate = new Date(Number(dateParts[2]), Number(dateParts[0]) - 1, Number(dateParts[1]));
                            if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
                                return 0;
                            }
                            if (cellDate < filterLocalDateAtMidnight) {
                                return -1;
                            }
                            if (cellDate > filterLocalDateAtMidnight) {
                                return 1;
                            }
                        },
                        browserDatePicker: true
                    }
                },
                {
                    headerName: "Expected Date",
                    field: "Expected Date",
                    filter: "agDateColumnFilter",
                    filterParams: {
                        comparator: (filterLocalDateAtMidnight, cellValue) => {
                            const dateAsString = cellValue;
                            if (dateAsString === null)
                                return -1;
                            const dateParts = dateAsString.split("/");
                            const cellDate = new Date(Number(dateParts[2]), Number(dateParts[0]) - 1, Number(dateParts[1]));
                            if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
                                return 0;
                            }
                            if (cellDate < filterLocalDateAtMidnight) {
                                return -1;
                            }
                            if (cellDate > filterLocalDateAtMidnight) {
                                return 1;
                            }
                        },
                        browserDatePicker: true
                    }
                },
                {
                    headerName: "Date Received",
                    field: "Date Received",
                    filter: "agDateColumnFilter",
                    filterParams: {
                        comparator: (filterLocalDateAtMidnight, cellValue) => {
                            const dateAsString = cellValue;
                            if (dateAsString === null)
                                return -1;
                            const dateParts = dateAsString.split("/");
                            const cellDate = new Date(Number(dateParts[2]), Number(dateParts[0]) - 1, Number(dateParts[1]));
                            if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
                                return 0;
                            }
                            if (cellDate < filterLocalDateAtMidnight) {
                                return -1;
                            }
                            if (cellDate > filterLocalDateAtMidnight) {
                                return 1;
                            }
                        },
                        browserDatePicker: true
                    }
                },
                {
                    headerName: "Total Order Cost",
                    field: "Total Order Cost",
                    filter: "agNumberColumnFilter",
                    type: "numericColumn",
                    cellRenderer: "numberFormatter"
                },
                {
                    headerName: "Total Order Unit Cost",
                    field: "Total Order Unit Cost",
                    filter: "agNumberColumnFilter",
                    type: "numericColumn",
                    cellRenderer: "numberFormatter"
                },
                {
                    headerName: "Individual Unit Price",
                    field: "Individual Unit Price",
                    filter: "agNumberColumnFilter",
                    type: "numericColumn",
                    cellRenderer: "numberFormatter"
                },
                {
                    headerName: "Quantity Ordered",
                    field: "Quantity Ordered"
                },
                {
                    headerName: "Tracking Number",
                    field: "Tracking Number"
                },
                {
                    headerName: "Credit Number",
                    field: "Credit Number"
                },
                {
                    headerName: "Shipping Charge",
                    field: "Shipping Cost",
                    filter: "agNumberColumnFilter",
                    type: "numericColumn",
                    cellRenderer: "numberFormatterOrderAnalytic"
                },
                {
                    headerName: "Distributor Credit",
                    field: "Credit Amount",
                    filter: "agNumberColumnFilter",
                    type: "numericColumn",
                    cellRenderer: "numberFormatterOrderAnalytic"
                },
                {
                    headerName: "Submission Date",
                    field: "Submission Date",
                    filter: "agDateColumnFilter",
                    filterParams: {
                        comparator: (filterLocalDateAtMidnight, cellValue) => {
                            const dateAsString = cellValue;
                            if (dateAsString === null)
                                return -1;
                            const dateParts = dateAsString.split("/");
                            const cellDate = new Date(Number(dateParts[2]), Number(dateParts[0]) - 1, Number(dateParts[1]));
                            if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
                                return 0;
                            }
                            if (cellDate < filterLocalDateAtMidnight) {
                                return -1;
                            }
                            if (cellDate > filterLocalDateAtMidnight) {
                                return 1;
                            }
                        },
                        browserDatePicker: true
                    }
                },
                {
                    headerName: "Approval Date",
                    field: "Approval Date",
                    filter: "agDateColumnFilter",
                    filterParams: {
                        comparator: (filterLocalDateAtMidnight, cellValue) => {
                            const dateAsString = cellValue;
                            if (dateAsString === null)
                                return -1;
                            const dateParts = dateAsString.split("/");
                            const cellDate = new Date(Number(dateParts[2]), Number(dateParts[0]) - 1, Number(dateParts[1]));
                            if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
                                return 0;
                            }
                            if (cellDate < filterLocalDateAtMidnight) {
                                return -1;
                            }
                            if (cellDate > filterLocalDateAtMidnight) {
                                return 1;
                            }
                        },
                        browserDatePicker: true
                    }
                },
                {
                    headerName: "Rejection Date",
                    field: "Rejection Date",
                    filter: "agDateColumnFilter",
                    filterParams: {
                        comparator: (filterLocalDateAtMidnight, cellValue) => {
                            const dateAsString = cellValue;
                            if (dateAsString === null)
                                return -1;
                            const dateParts = dateAsString.split("/");
                            const cellDate = new Date(Number(dateParts[2]), Number(dateParts[0]) - 1, Number(dateParts[1]));
                            if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
                                return 0;
                            }
                            if (cellDate < filterLocalDateAtMidnight) {
                                return -1;
                            }
                            if (cellDate > filterLocalDateAtMidnight) {
                                return 1;
                            }
                        },
                        browserDatePicker: true
                    }
                }
            ],
            rowSelection: "single",
            rowData: [],
            multiSortKey: "ctrl",
            floatingFilter: true,
            frameworkComponents: {
                numberFormatter: number_formatter_1.NumberFormatter,
                numberFormatterOrderAnalytic: number_formatter_order_analytic_1.NumberFormatterOrderAnalytic
            }
        };
    }
    async componentDidMount() {
        if (store_1.reportsStore.editModal) {
            await store_1.reportsStore.loadOrderAnalytics();
        }
    }
    componentWillUnmount() {
        store_1.reportsStore.orderAnalyticsData = null;
    }
    render() {
        //B-088
        const storeData = store_1.reportsStore.orderAnalyticsData;
        if (!store_2.usersStore.permissions.ReadPharmacies) {
            let filteredDataAsPerPharmacy = storeData === null || storeData === void 0 ? void 0 : storeData.filter((item) => {
                var _a;
                return (_a = store_2.usersStore.user.value.sites) === null || _a === void 0 ? void 0 : _a.includes(item.siteId);
            });
            this.storeData.rowData = filteredDataAsPerPharmacy;
        }
        else {
            this.storeData.rowData = storeData;
        }
        const loadingData = store_1.reportsStore.showLoader;
        if (storeData && storeData.length > 0) {
            return (React.createElement(React.Fragment, null,
                React.createElement(order_analytics_header_1.OrderAnalyticsHeader, { title: "Order Analytics", withDatePicker: true }),
                React.createElement("div", { className: "ag-theme-balham", style: {
                        height: "85%",
                        width: "100%"
                    } },
                    React.createElement("button", { onClick: this.onButtonExport.bind(this) }, "Export to CSV"),
                    React.createElement(ag_grid_react_1.AgGridReact, { onGridReady: params => (this.storeData.gridApi = params.api), rowSelection: this.storeData.rowSelection, columnDefs: this.storeData.columnDefs, defaultColDef: this.storeData.defaultColDef, frameworkComponents: this.storeData.frameworkComponents, multiSortKey: this.storeData.multiSortKey, animateRows: true, sideBar: true, groupMultiAutoColumn: true, floatingFilter: this.storeData.floatingFilter, suppressExcelExport: true, rowData: this.storeData.rowData }))));
        }
        if (storeData) {
            if (loadingData) {
                return (React.createElement(React.Fragment, null,
                    React.createElement(order_analytics_header_1.OrderAnalyticsHeader, { title: "Order Analytics", withDatePicker: true }),
                    React.createElement("div", null, "Loading Data...")));
            }
            // Return a Custom built component here to handle 0 data returned.
            return (React.createElement(no_data_found_1.default, { headerComponent: React.createElement(order_analytics_header_1.OrderAnalyticsHeader, { title: "Order Analytics", withDatePicker: true }) }));
        }
        return React.createElement(ui_1.UiLoadingIndicator, null);
    }
};
OrderAnalytics = __decorate([
    mobx_react_1.observer
], OrderAnalytics);
exports.OrderAnalytics = OrderAnalytics;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/reporting/modules/reporting-list/components/report-container/order-analytics/order-analytics.tsx
// module id = 3925
// module chunks = 0